import React from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@material-ui/styles/makeStyles';

import ItemLoadingCard from './ItemLoadingCard';
import ItemCard from './ItemCard';

export interface IItemCard {
    id: number;
    name: string;
    category: string;
    total: string;
    revenue: string;
    photoUrl?: string;
}

interface IProps {
    title: string;
    loading?: boolean;
    items: IItemCard[];
    label?: string;
    allVenues?: boolean;
}

const useStyles = makeStyles({
    topFive: {
        color: '#8D98B7',
        padding: '30px',
        width: '100%',
        boxSizing: 'border-box',
    },
    topFiveTitle: {
        textTransform: 'capitalize',
    },
    list: {
        margin: '0',
        padding: '0',
        listStyle: 'none',
        maxHeight: '50vh',
        overflowY: 'auto',
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#F5F5F5',
        },
        '&::-webkit-scrollbar': {
            width: '6px',
            backgroundColor: '#F5F5F5',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#ced1da',
        },
        '@media only screen and max-width(600px)': {
            boxSizing: 'border-box',
            padding: '6px',
            width: '100%',
        },
        '@media only screen and max-width(1200px)': {
            display: 'flex',
            flexWrap: 'wrap',
            position: 'relative',
            maxHeight: 'none',
            overflow: 'visible',
        },
    },
    itemWrapper: {
        '@media only screen and max-width(600px)': {
            boxSizing: 'border-box',
            padding: '6px',
            width: '100%',
        },
        '@media only screen and max-width(1200px)': {
            boxSizing: 'border-box',
            padding: '6px',
            flex: '1 1 33%',
        },
    },
    topFiveNoData: {},
    topFiveNoDataHeader: {},
});

const CategorySummaryTopFive = (props: IProps) => {
    const { t } = useTranslation();
    const Styles = useStyles();

    return (
        <div className={Styles.topFive}>
            {props.items.length > 0 && <div className={Styles.topFiveTitle}>{props.title}</div>}
            <ul className={Styles.list}>
                {props.loading ? (
                    <div key={'loading'} className={Styles.itemWrapper}>
                        <ItemLoadingCard />
                    </div>
                ) : props.items.length > 0 ? (
                    props.items
                        .sort((a, b) => parseFloat(b.total) - parseFloat(a.total))
                        .map((item) => {
                            return (
                                <div key={item.id} className={Styles.itemWrapper}>
                                    <ItemCard {...item} label={props.label} allVenues={props.allVenues} />
                                </div>
                            );
                        })
                ) : (
                    <div className={Styles.topFiveNoData}>
                        <p className={Styles.topFiveNoDataHeader}>{t('dashboard.noData')}</p>
                        <p>{t('dashboard.tryDifferent')}</p>
                    </div>
                )}
            </ul>
        </div>
    );
};

export default CategorySummaryTopFive;
